import React from 'react';
import dmImage from "../../../assets/images/approvals/rta.png";
import dmccImage from "../../../assets/images/approvals/dm.png";
import difcImage from "../../../assets/images/approvals/approval1.jpg";

import approval from "../../../assets/images/approvals/dm.png";
import { CiCircleChevRight } from "react-icons/ci"; 
import { FaQuoteRight } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// import required modules
import { Pagination } from 'swiper/modules';
import Metatag from '../../Metatag/Metatag';

const Municipalityapproval = () => {
  return (
    <div>
        <Metatag title="Municipality Approval Services -Fast & Reliable Assistance | Megavolt Technical Services" description="Simplify your municipality approval process with
Megavolt Technical Services. Expert guidance for
permits, approvals, and compliance. Get quick, hassle-
free solutions tailored to your needs " link="approval/multicommodities-approval"/>
        <div className='container relative'>
            <div className='grid grid-cols-1 md:grid-cols-12 md:py-16 py-8 gap-5'>
                <div className='col-span-12 md:col-span-8'>
                    <div className='p-3'>
                        <div className='w-[200px] border'>
                            <img src={approval} alt="our story" className="h-full w-full" />
                        </div>
                        <div className='my-5'>
                            <h1 className="mb-4 text-2xl font-bold captilize dark:text-[#dddddd] md:text-3xl">
                                Dubai Municipality (DM) Approved Contractor
                            </h1>   
                            <p className='pl-3'>
                                We are a trusted Dubai Municipality Approved Contractor, offering complete support for Dubai Municipality approvals, building permits, fit-out approvals, inspections, and compliance services. Our experienced team ensures every project strictly follows Dubai Municipality regulations, local building codes, safety standards, and technical guidelines, delivering approvals smoothly and on time.
                            </p>
                            <p className="pl-3 pt-2">
              Looking for fast and reliable Dubai Municipality approval in Dubai? Contact Megavolt today for professional and hassle-free approval services.
            </p>
                        </div>
                                  <div className="my-5">
            <h1 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              About Our Dubai Municipality Approval Services
            </h1>
            <p className="pl-3 pt-2">
              Dubai Municipality approval is mandatory for construction, fit-out works, renovations, electrical and mechanical works, interior modifications, and commercial projects across Dubai. As a DM-approved contractor, we handle the entire approval process from initial documentation to final completion certificates ensuring your project proceeds without delays or compliance risks.

Our Dubai Municipality approval services are designed to save time, reduce costs, and ensure full regulatory compliance for residential, commercial, and industrial projects.
            </p>
          </div>
                        <div className='my-10'>
                            <h1 className="mb-4 text-2xl font-bold captilize dark:text-[#dddddd] md:text-3xl">
                                 Why Choose a Dubai Municipality Approved Contractor?
                            </h1>
                            <ul className='list-disc ml-10 space-y-2'>
                                <li>Fully compliant with Dubai Municipality laws and regulations.</li>
                                <li>Faster and smoother Dubai Municipality approval process.</li>
                                <li>Experienced engineers and approval specialists.</li>
                                <li>Complete documentation and authority coordination.</li>
                                <li>Reduced risk of rejection, penalties, or delays.</li>
                                <li>End-to-end approval and execution support.</li>
                                <li>Reliable project delivery with on-time completion.</li>
                            </ul>
                        </div>
                        <div className='my-5'>
                            <h1 className="mb-4 text-2xl font-bold captilize dark:text-[#dddddd] md:text-3xl">
                            Dubai Municipality Approval Process – Step by Step
                            </h1>
                            <div className="mb-5">
                                <div className="flex">
                                    <div className="mr-5 relative mx-auto mb-5 sm:mb-0 z-[2] before:absolute before:top-12 before:left-1/2 before:-bottom-[15px] before:-translate-x-1/2 before:border-l-2 before:border-[#ebedf2] before:w-0 before:h-auto before:-z-[1] dark:before:border-[#191e3a] before:hidden sm:before:block">
                                        <span className="bg-orange text-white inline-flex items-center justify-center w-12 h-12 mx-auto rounded-full shadow-[0_4px_9px_0_rgba(31,45,61,0.31)]">1</span>
                                    </div>
                                    <div className="flex-1 mb-10">
                                        <p className="">Initial Consultation: We evaluate your project scope, location, and Dubai Municipality requirements.</p> 
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="mr-5 relative mx-auto mb-5 sm:mb-0 z-[2] before:absolute before:top-12 before:left-1/2 before:-bottom-[15px] before:-translate-x-1/2 before:border-l-2 before:border-[#ebedf2] before:w-0 before:h-auto before:-z-[1] dark:before:border-[#191e3a] before:hidden sm:before:block">
                                        <span className="bg-orange text-white inline-flex items-center justify-center w-12 h-12 mx-auto rounded-full shadow-[0_4px_9px_0_rgba(31,45,61,0.31)]">2</span>
                                    </div>
                                    <div className="flex-1 mb-10">
                                        <p className="">Project & Contractor Registration: Registration of company details, consultants, and project data with Dubai Municipality systems.</p> 
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="mr-5 relative mx-auto mb-5 sm:mb-0 z-[2] before:absolute before:top-12 before:left-1/2 before:-bottom-[15px] before:-translate-x-1/2 before:border-l-2 before:border-[#ebedf2] before:w-0 before:h-auto before:-z-[1] dark:before:border-[#191e3a] before:hidden sm:before:block">
                                        <span className="bg-orange text-white inline-flex items-center justify-center w-12 h-12 mx-auto rounded-full shadow-[0_4px_9px_0_rgba(31,45,61,0.31)]">3</span>
                                    </div>
                                    <div className="flex-1 mb-10">
                                        <p className="">Document Preparation & Submission: Preparation and submission of drawings, layouts, method statements, and required documents.</p> 
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="mr-5 relative mx-auto mb-5 sm:mb-0 z-[2] before:absolute before:top-12 before:left-1/2 before:-bottom-[15px] before:-translate-x-1/2 before:border-l-2 before:border-[#ebedf2] before:w-0 before:h-auto before:-z-[1] dark:before:border-[#191e3a] before:hidden sm:before:block">
                                        <span className="bg-orange text-white inline-flex items-center justify-center w-12 h-12 mx-auto rounded-full shadow-[0_4px_9px_0_rgba(31,45,61,0.31)]">4</span>
                                    </div>
                                    <div className="flex-1 mb-10">
                                        <p className="">Technical Review by Dubai Municipality: Assessment of architectural, structural, MEP, safety, and compliance details.</p> 
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="mr-5 relative mx-auto mb-5 sm:mb-0 z-[2] before:absolute before:top-12 before:left-1/2 before:-bottom-[15px] before:-translate-x-1/2 before:border-l-2 before:border-[#ebedf2] before:w-0 before:h-auto before:-z-[1] dark:before:border-[#191e3a] before:hidden sm:before:block">
                                        <span className="bg-orange text-white inline-flex items-center justify-center w-12 h-12 mx-auto rounded-full shadow-[0_4px_9px_0_rgba(31,45,61,0.31)]">5</span>
                                    </div>
                                    <div className="flex-1 mb-10">
                                        <p className="">Site Inspection & Compliance Check: On-site inspections by Dubai Municipality to verify approved plans and safety standards.</p> 
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="mr-5 relative mx-auto mb-5 sm:mb-0 z-[2] before:absolute before:top-12 before:left-1/2 before:-bottom-[15px] before:-translate-x-1/2 before:border-l-2 before:border-[#ebedf2] before:w-0 before:h-auto before:-z-[1] dark:before:border-[#191e3a] before:hidden sm:before:block">
                                        <span className="bg-orange text-white inline-flex items-center justify-center w-12 h-12 mx-auto rounded-full shadow-[0_4px_9px_0_rgba(31,45,61,0.31)]">6</span>
                                    </div>
                                    <div className="flex-1 mb-10">
                                        <p className="">Final Dubai Municipality Approval: Issuance of DM approval, completion certificate, or clearance for legal project execution.</p> 
                                    </div>
                                </div>
                            </div>
                        </div>
                                <div className="my-5">
            <h1 className="text-2xl font-bold capitalize dark:text-[#dddddd] md:text-3xl">
              Trusted Dubai Municipality Approval Experts in Dubai
            </h1>
            <p className="pl-3 pt-2">
              With strong expertise in Dubai Municipality systems, approval workflows, and local compliance standards, Megavolt ensures your approvals are handled professionally and efficiently. Whether it’s a fit-out project, commercial space, residential renovation, or large-scale development, we provide reliable Dubai Municipality approval solutions in Dubai. Call our experts at +971 55 481 2897 for fast, compliant, and stress-free Dubai Municipality approvals.
            </p>
          </div>
                    </div>
                </div>
                <div className='col-span-12 md:col-span-4 p-3'>
                    <div className='sticky top-[15%] border border-[#bcbcbc] p-3 rounded-lg bg-[#e8eaed]'>
                       <p className='uppercase text-center mb-5 text-xl font-bold'>Other Authority Approval
                       </p>
                       <div className='space-y-5'>
                            <div className='border border-orange w-[60%] mx-auto'>
                                <img src={dmImage} alt="our story" className="h-full w-full" />
                            </div>
                            <div className='border border-orange w-[60%] mx-auto'>
                                <img src={dmccImage} alt="our story" className="h-full w-full" />
                            </div>
                            <div className='border border-orange w-[60%] mx-auto'>
                                <img src={difcImage} alt="our story" className="h-full w-full" />
                            </div>
                                                     
                       </div>
                    </div>
                </div>
            </div>
        </div>

        <div className='p-3 md:py-12'>
            <div className="text-center my-2">
                <h1 className=" font-bold text-2xl md:text-3xl text-center uppercase">What Clients Say</h1> 
            </div>
            <p className="text-center text-orange lg:text-2xl text-xl ">
                We care about our clients, so we are popular
            </p>
            <div className="md:my-10 my-8">
                <Swiper
                    pagination={{ clickable: true }}
                    modules={[Pagination]}
                    className="mySwiper"
                    slidesPerView={1}
                    spaceBetween={30}
                    breakpoints={{
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 40,
                    },
                    1024: {
                        slidesPerView: 1,
                        spaceBetween: 50,
                    },
                    }}
                >
                    <SwiperSlide className='md:p-12 p-4'>
                        <div className='mb-[40px] shadow-[0_5px_20px_#01010145] p-5 rounded-xl'>
                           <div className='text-center shadow-[0_1rem_3rem_rgba(0, 0, 0, .18)]'>
                                <div className='flex items-center justify-center'>
                                    <FaQuoteRight className='text-orange text-[40px] mb-5'/>
                                </div>
                                <p className='text-center md:text-lg text-base'>
                                Team did an amazing job for us. On a very short time plan they developed a great presentation out of a word report. Communication was fast, uncomplicated and wished changes were done within hours. I can highly recommend them. </p>
                                <h1 className='text-center font-bold mt-3'>John Hanks, Entrepreneur </h1>
                           </div>

                        </div>
                    </SwiperSlide>
                    <SwiperSlide className='md:p-12 p-4'>
                        <div className='mb-[40px] shadow-[0_5px_20px_#01010145] p-5 rounded-xl'>
                           <div className='text-center shadow-[0_1rem_3rem_rgba(0, 0, 0, .18)]'>
                                <div className='flex items-center justify-center'>
                                    <FaQuoteRight className='text-orange text-[40px] mb-5'/>
                                </div>
                                <p className='text-center md:text-lg text-base'>
                                Team did an amazing job for us. On a very short time plan they developed a great presentation out of a word report. Communication was fast, uncomplicated and wished changes were done within hours. I can highly recommend them. </p>
                                <h1 className='text-center font-bold mt-3'>John Hanks, Entrepreneur </h1>
                           </div>

                        </div>
                    </SwiperSlide>
                    <SwiperSlide className='md:p-12 p-4'>
                        <div className='mb-[40px] shadow-[0_5px_20px_#01010145] p-5 rounded-xl'>
                           <div className='text-center shadow-[0_1rem_3rem_rgba(0, 0, 0, .18)]'>
                                <div className='flex items-center justify-center'>
                                    <FaQuoteRight className='text-orange text-[40px] mb-5'/>
                                </div>
                                <p className='text-center md:text-lg text-base'>
                                Team did an amazing job for us. On a very short time plan they developed a great presentation out of a word report. Communication was fast, uncomplicated and wished changes were done within hours. I can highly recommend them. </p>
                                <h1 className='text-center font-bold mt-3'>John Hanks, Entrepreneur </h1>
                           </div>

                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
        </div>
    </div>
  )
}

export default Municipalityapproval